import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleModPriceUrls } from '@custom/Utils/constants/apiUrls';

type editPayloadType = {
  _id: string;
  credit: number;
  studyRegion: string;
  modality: string;
};

// Async thunk to update a teleradiology modality price
export const editTeleModPrice = createAsyncThunk(
  'editTeleModPrice',
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_teleModPriceUrls?.edit, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to update modality price. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the updated data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

// You can export all thunks together if needed
export default editTeleModPrice;
